import React from "react";
import Slider from "react-slick";
import { servicios } from "../properties";
import { goTo } from "../tools";
import { connect } from "react-redux";

const mapDispatch = (dispatch) => {
	return {
		addEvento: (evento) => {
			dispatch({ "type": "HOME_SET_EVENT", "evento": evento });
		}
	};
};

class Carrousel extends React.Component {

	irPortal = (url) => {
		goTo(url);
	}

	open = (event) => {
		this.props.addEvento(event);
	}

	render() {
		var settings = {
			dots: false,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 5000,
			infinite: true,
			speed: 500,
			slidesToShow: 4,
			slidesToScroll: 4,
			initialSlide: 0,
			responsive: [{
				breakpoint: 800,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: false,
					dots: false,
					arrows: false
				}
			}, {
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2,
					dots: false,
					arrows: false
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
					arrows: false
				}
			}]
		};
		return (
			<div className="carrusel-container">
				<div className="contenedor-carrusel container">
					<Slider {...settings}>
						<div>
							<div className="carrusel-noticias">
								<p className="titulo">¿Ya conoces nuestra aplicación?</p>
								<img src={require("../img/carrusel-01.gif")} />
								<p className="subtitulo">Consulta información de tu Seguro, reporta un siniestro, solicita asistencia vial y mucho más.</p>
							</div>
						</div>
						<div>
							<div className="carrusel-noticias">
								<p className="titulo">Soy Cliente y App Soy Cliente GNP	</p>
								<a onClick={this.open.bind(this, "banner2")} target="_blank">
									<img src={require("../img/carrusel-02.gif")} />
								</a>
								<p className="subtitulo">¡Conoce los beneficios que te brindan nuestras plataformas digitales!</p>
							</div>
						</div>
						<div>
							<div className="carrusel-noticias">
								<p className="titulo">Conoce nuestro portal</p>
								<a onClick={this.open.bind(this, "banner3")} href={servicios.app + "/#!/gnp/servicios-videos"} target="_blank">
									<img src={require("../img/carrusel-03.gif")} />
								</a>
								<p className="subtitulo">Aquí podrás ver videos explicativos y conocer los grandes beneficios que tenemos para ti.</p>
							</div>
						</div>
						<div>
							<div className="carrusel-noticias">
								<p className="titulo">¿Necesitas ayuda?</p>
								<img src={require("../img/carruselgif-linea-gnp-portal.gif")} />
								<p className="subtitulo">¡Estamos para servirte!</p>
							</div>
						</div>
						<div>
							<div className="carrusel-noticias">
								<p className="titulo">Paga en línea tu Póliza de Seguro</p>
								<a onClick={this.open.bind(this, "banner5")} href={servicios.app + "/#!/gnp/servicios-videos/15"} target="_blank">
									<img src={require("../img/carrusel-05.gif")} />
								</a>
								<p className="subtitulo">Consulta aquí el tutorial para realizar el Pago en línea de tu Seguro.</p>
							</div>
						</div>
						<div>
							<div className="carrusel-noticias">
								<p className="titulo">Brinda un Acceso Compartido</p>
								<a onClick={this.open.bind(this, "banner5")} href={servicios.app + "/#!/gnp/servicios-videos/3"} target="_blank">
									<img src={require("../img/carrusel-06.gif")} />
								</a>
								<p className="subtitulo">Consulta aquí el video tutorial.</p>
							</div>
						</div>
					</Slider>
				</div>
			</div>
		);
	}
}

export default connect(null, mapDispatch)(Carrousel);



// WEBPACK FOOTER //
// ./src/carrusel/carrusel.cmpt.js